import { render, staticRenderFns } from "./DynComments.vue?vue&type=template&id=8ac62180&scoped=true"
import script from "./DynComments.vue?vue&type=script&lang=js"
export * from "./DynComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac62180",
  null
  
)

export default component.exports